import {StyledCopyEmailButton} from './CopyContentStyles'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CheckIcon from '@mui/icons-material/Check'
import {useCallback, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import CopyToClipboard from 'react-copy-to-clipboard'
import parse from 'html-react-parser'

export const disclaimer =
  'Note: Responses are generated using generative AI technology. Please review to confirm accuracy.'

const CopyContent = ({unparsedData, marginRequired}) => {
  const [copied, setCopied] = useState(false)
  const onCopy = useCallback(() => {
    setCopied(true)
  }, [setCopied])

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false)
      }, 2000)
    }
  }, [copied])
  return (
    <CopyToClipboard onCopy={onCopy} text={disclaimer + '\n\n' + parse(unparsedData || '')}>
      <StyledCopyEmailButton variant="outlined" startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}>
        {copied ? 'Copied' : `Copy to clipboard`}
      </StyledCopyEmailButton>
    </CopyToClipboard>
  )
}

CopyContent.propTypes = {
  unparsedData: PropTypes.string,
  marginRequired: PropTypes.bool
}

export default CopyContent
